import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["user.loading"],
  loading => loading
);
